(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];

  const banner_with_text = () => {
    const main = document.querySelector('main');
    const headerOverlay = document.querySelector('.overlay');
    const breadCrumb = document.querySelector('.main-breadcrumb');
    const colorScheme = document.querySelector('.header-color-light');
    const colorSchemeDark = document.querySelector('.header-color-dark');
    // Use first child traversal — avoids :first-of-type style recalculation
    const firstSection = main && main.querySelector('.shopify-section');

    if (headerOverlay && firstSection && firstSection.classList.contains('section-banner-with-text')) {
      main.classList.add('page-about');
      if (colorScheme) {
        headerOverlay.classList.add('theme-dark', 'header-color-background-5');
        breadCrumb && breadCrumb.classList.add('color-background-5');
      }
      if (colorSchemeDark) {
        headerOverlay.classList.remove('theme-dark', 'header-color-background-5');
        headerOverlay.classList.add('color-background-1');
        breadCrumb && breadCrumb.classList.remove('color-background-5');
      }
    } else {
      const pageAbout = document.querySelector('.page-about');
      const pageLookbook = document.querySelector('.page-lookbook');
      if (pageAbout || pageLookbook) {
        if (colorScheme) breadCrumb && breadCrumb.classList.add('color-background-5');
        if (colorSchemeDark) breadCrumb && breadCrumb.classList.remove('color-background-5');
      }
    }
  };

  banner_with_text();

  events.forEach(function (item) {
    document.addEventListener(item, function () {
      banner_with_text();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["browse-first"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('.ctm-browse-first-inner');
    if (!el) return;

    function initSwiper() {
      new Swiper(el, {
        slidesPerView: 4.5,
        spaceBetween: 4,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: { slidesPerView: 2.45 },
          576: { slidesPerView: 2.45 },
          992: { slidesPerView: 4.5 },
          1200: { slidesPerView: 6 },
        },
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          requestAnimationFrame(initSwiper);
        }
      }, { rootMargin: '200px' });
      observer.observe(el);
    } else {
      initSwiper();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall();
		}
		showActiveMedia() {
			this.querySelectorAll(
				`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
					'data-media-id'
				)}"])`
			).forEach((element) => {
				element.classList.remove('active');
			});

			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			);
			const activeMediaTemplate = activeMedia.querySelector('template');
			const activeMediaContent = activeMediaTemplate
				? activeMediaTemplate.content
				: null;
			activeMedia.classList.add('active');

			activeMedia.scrollIntoView();

			if (
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMediaContent &&
				activeMediaContent.querySelector('.js-youtube')
			)
				activeMedia.loadContent();
		}

		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			);
			let activeMediaIndex = 0;

			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
				if (element == activeMedia) {
					activeMediaIndex = index;
				}
			});

			const prodPageSwiper = new Swiper('#product-page-swiper', {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				a11y: false,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: '.swiper-button-next-prod-page',
					prevEl: '.swiper-button-prev-prod-page',
				},
				pagination: {
					el: '.swiper-pagination-product-page',
					clickable: true,
				},
				on: {
					click: function (e) {
						if (this.zoom.scale === 1) {
							this.zoom.in();
						} else {
							this.zoom.out();
						}
					},
				},
			});

			prodPageSwiper.on('init', function () {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init();

			document
				.querySelector('.product-media-modal__toggle')
				.addEventListener('click', function () {
					prodPageSwiper.destroy();
				});
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.elements.panel.addEventListener('click', this.onItemClick.bind(this));
    }

    renderList() {
      const data = this.querySelector('script[data-countries]');
      if (!data || this.elements.panel.children.length) return;
      const current = this.elements.input.value;
      const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
      this.elements.panel.innerHTML = JSON.parse(data.textContent)
        .map(([iso, name, currency, symbol]) => {
          const active = iso === current;
          return `<li class="disclosure__item" tabindex="-1"><a class="link link--text disclosure__link disclosure__link--flag caption-large${active ? ' disclosure__link--active' : ''} focus-inset" href="#"${active ? ' aria-current="true"' : ''} data-value="${iso}" data-flag="${currency}"><span class="flag-icon flag-icon-${iso.toLowerCase()}" aria-hidden="true"></span> ${esc(name)} <span class="localization-form__currency">(${currency} ${esc(symbol)})</span></a></li>`;
        })
        .join('');
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      const item = event.target.closest('a[data-value]');
      if (!item) return;
      event.preventDefault();
      this.elements.input.value = item.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.renderList();
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
		class StickyHeader extends HTMLElement {
		constructor() {
		super();
		}

		connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.header_overlay = document.querySelector('.header');
		this.headerOverlay = document.querySelector('.overlay');

		this.headerBounds = {};
		this.predictiveSearch = this.querySelector('predictive-search');
		this.currentScrollTop = 0;

		this.logoSlideshowFirst = document.querySelector('.first-logo-slideshow');
		this.logoSlideshowFirstHeight = 0;

		if (this.logoSlideshowFirst) {
			// Defer initial read to after first paint — avoids 0 height if CSS not yet applied
			requestAnimationFrame(() => {
				this.logoSlideshowFirstHeight = this.logoSlideshowFirst.offsetHeight;
			});
			if ('ResizeObserver' in window) {
				this._resizeObserver = new ResizeObserver(() => {
					this.logoSlideshowFirstHeight = this.logoSlideshowFirst.offsetHeight;
				});
				this._resizeObserver.observe(this.logoSlideshowFirst);
			}
		}

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		}

		disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
		if (this._resizeObserver) this._resizeObserver.disconnect();
		}

		createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
		}



		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.logoSlideshowFirst) {
				const logoSlideshowFirstHeight = this.logoSlideshowFirstHeight;
				if (scrollTop > this.currentScrollTop && scrollTop > logoSlideshowFirstHeight && scrollTop > this.headerBounds.bottom) {
					requestAnimationFrame(this.hide.bind(this));
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				} else if (scrollTop - logoSlideshowFirstHeight < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
					requestAnimationFrame(this.reveal.bind(this));
				} else if (scrollTop - logoSlideshowFirstHeight <= this.headerBounds.top) {
					requestAnimationFrame(this.reset.bind(this));
				}

				this.currentScrollTop = scrollTop;
			} else {
				if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			requestAnimationFrame(this.hide.bind(this));
			if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
				this.predictiveSearch.onFocusOut();
				this.predictiveSearch.onBlur();
			} 
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			requestAnimationFrame(this.reveal.bind(this));
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
			}
		}

		hide() {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			//this.closeSearchModal();
		}

		reveal() {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.headerOverlay && this.header_overlay.classList.add('header_overlay-scroll');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			this.headerOverlay && this.header_overlay.classList.remove('header_overlay-scroll');
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => {
			if (typeof disclosure.close === 'function') disclosure.close();
		});
		}

		closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

	const events = [
	"shopify:section:reorder",
	"shopify:section:deselect",
	"shopify:section:select",
	"shopify:section:unload",
	"shopify:section:load",
];

	const headerOverlayEl = document.querySelector(".overlay");
	const mainEl = document.querySelector("main");

	const applyHeaderOverlay = () => {
		if (headerOverlayEl) {
			mainEl && mainEl.classList.add("header_overlay");
		} else {
			mainEl && mainEl.classList.remove("header_overlay");
		}
	};

	const updateHeaderHeight = (height) => {
		document.documentElement.style.setProperty('--my-header-height', height + "px");
	};

	applyHeaderOverlay();

	if (headerOverlayEl) {
		if ('ResizeObserver' in window) {
			new ResizeObserver(function(entries) {
				updateHeaderHeight(entries[0].contentRect.height);
			}).observe(headerOverlayEl);
		} else {
			updateHeaderHeight(headerOverlayEl.offsetHeight);
		}
	}

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			applyHeaderOverlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  for (const p of document.querySelectorAll('.article-template__content p')) {
    if (p.innerText == p.innerHTML) {
      p.classList.add('only');
    }
  }

  for (const p of document.querySelectorAll('.article-template__content p > a')) {
    p.parentElement.classList.add('only');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const blog_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	blog_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			blog_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const main_collection_banner = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	main_collection_banner();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			main_collection_banner();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });

      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
        },
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
          renderBullet: function (index, className) {
            return '<li class="' + className + '" role="tab" aria-label="Go to slide ' + (index + 1) + '"></li>';
          },
        },
        on: {
          click: function (e) {
            if (this.zoom.scale === 1) {
              this.zoom.in();
            } else {
              this.zoom.out();
            }
          },
        },
      });

      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();

      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              document.dispatchEvent(new CustomEvent('product-recommendations:loaded'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-bg-with-text"] && !Shopify.designMode) return;
  try {
    
    const events = [
      'shopify:section:reorder',
      'shopify:section:deselect',
      'shopify:section:select',
      'shopify:section:unload',
      'shopify:section:load',
    ];

    const banner_with_text = () => {
      const main = document.querySelector('main');
      const headerOverlay = document.querySelector('.overlay');
      const breadCrumb = document.querySelector('.main-breadcrumb');
      const colorScheme = document.querySelector('.header-color-light');
      const colorSchemeDark = document.querySelector('.header-color-dark');
      const firstSection = main && main.querySelector('.shopify-section');

      if (headerOverlay && firstSection && firstSection.classList.contains('section-banner-with-text')) {
        main.classList.add('page-about');
        if (colorScheme) {
          headerOverlay.classList.add('theme-dark', 'header-color-background-5');
          breadCrumb && breadCrumb.classList.add('color-background-5');
        }
        if (colorSchemeDark) {
          headerOverlay.classList.remove('theme-dark', 'header-color-background-5');
          headerOverlay.classList.add('color-background-1');
          breadCrumb && breadCrumb.classList.remove('color-background-5');
        }
      } else {
        const pageAbout = document.querySelector('.page-about');
        const pageLookbook = document.querySelector('.page-lookbook');
        if (pageAbout || pageLookbook) {
          if (colorScheme) breadCrumb && breadCrumb.classList.add('color-background-5');
          if (colorSchemeDark) breadCrumb && breadCrumb.classList.remove('color-background-5');
        }
      }
    };

    banner_with_text();

    events.forEach(function (item) {
      document.addEventListener(item, function () {
        banner_with_text();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var _mainColorCache = null;

function initRecommendationSwiper(swiperEl) {
  if (!swiperEl || typeof Swiper === 'undefined') return;
  var section = swiperEl.closest('[data-rec-section], [data-page-recommendations]');
  if (!section) return;
  var nextBtn = section.querySelector('.next-tabbing-btn');
  var prevBtn = section.querySelector('.peev-tabbing-btn');
  if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
  requestAnimationFrame(function() {
    new Swiper(swiperEl, {
      loop: false,
      spaceBetween: 10,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      breakpoints: {
        0: { slidesPerView: 1.3 },
        375: { slidesPerView: 2.3 },
        990: { slidesPerView: 3.3 },
        1280: { slidesPerView: 5.5 },
      },
    });
  });
}

function clearShopifyRecSlides(section) {
  section.querySelectorAll('[data-shopify-rec-slide]').forEach(function(s) { s.remove(); });
}

function fetchShopifyRecommendations(wrapper, swiperEl, section) {
  var url = section.dataset.shopifyRecommendationsUrl;
  if (!url) { section.style.display = 'none'; return; }
  fetch(url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var slides = doc.querySelectorAll('[data-rec-slide]');
      if (!slides.length) { section.style.display = 'none'; return; }
      slides.forEach(function(slide) {
        slide.dataset.shopifyRecSlide = '1';
        wrapper.appendChild(slide);
      });
      updateRecommendationHeading(null);
      initRecommendationSwiper(swiperEl);
      if (_mainColorCache) syncRecommendationSwatches(_mainColorCache);
    })
    .catch(function() { section.style.display = 'none'; });
}

function loadColorPool(section, pool) {
  if (!pool._loading) {
    var url = section.dataset.productUrl + '?variant=' + pool.dataset.poolVariant + '&section_id=' + section.dataset.sectionId;
    pool._loading = fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-color-pool="' + pool.dataset.colorPool + '"]');
        if (src) Array.from(src.children).forEach(function(slide) { pool.appendChild(slide); });
        if (typeof checkSwatches === 'function') checkSwatches();
        if (typeof initSwatchSwipers === 'function') initSwatchSwipers();
      })
      .catch(function() {})
      .then(function() { delete pool.dataset.poolVariant; });
  }
  return pool._loading;
}

function showColorCollection(color) {
  var section = document.querySelector('[data-rec-section]');
  if (!section || !color) return;
  var colorHandle = color.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  var swiperEl = section.querySelector('.product-recommendations');
  if (!swiperEl) return;
  var wrapper = swiperEl.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  var lazyPool = section.querySelector('[data-color-pool="' + colorHandle + '"][data-pool-variant]');
  if (lazyPool) {
    loadColorPool(section, lazyPool).then(function() {
      if (_mainColorCache === color) showColorCollection(color);
    });
    return;
  }

  if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
  clearShopifyRecSlides(section);

  // Return slides currently in wrapper back to their source color pools
  Array.from(wrapper.querySelectorAll('[data-rec-slide]')).forEach(function(slide) {
    var srcPool = slide.dataset.poolHandle
      ? section.querySelector('[data-color-pool="' + slide.dataset.poolHandle + '"]')
      : null;
    if (srcPool) srcPool.appendChild(slide);
    else slide.remove();
  });

  var pool = section.querySelector('[data-color-pool="' + colorHandle + '"]');
  var slides = pool ? Array.from(pool.querySelectorAll('[data-rec-slide]')) : [];

  if (slides.length) {
    slides.forEach(function(slide) {
      slide.dataset.poolHandle = colorHandle;
      wrapper.appendChild(slide);
    });
    updateRecommendationHeading(color);
    initRecommendationSwiper(swiperEl);
    syncRecommendationSwatches(color);
    section.style.display = '';
  } else {
    fetchShopifyRecommendations(wrapper, swiperEl, section);
  }
}

function syncRecommendationSwatches(colorValue) {
  if (!colorValue) return;
  var colorLower = colorValue.toLowerCase().trim();
  document.querySelectorAll('[data-rec-section] .js-color-swatches-wrapper').forEach(function(wrap) {
    var inputs = Array.from(wrap.querySelectorAll('.js-color-swatches input.color-swatch-input'));
    var match = inputs.find(function(i) {
      return (i.dataset.variantValue || i.value || '').toLowerCase().trim() === colorLower;
    }) || inputs.find(function(i) {
      return (i.dataset.variantValue || i.value || '').toLowerCase().trim().startsWith(colorLower);
    });
    if (match && !match.checked) {
      match.checked = true;
      if (typeof updateSwatchSelection === 'function') updateSwatchSelection(match, wrap);
    }
  });
}

function syncCrossSellSwatches(colorValue, doUpdate) {
  var checkedMain = document.querySelector('.main-product-page .color-swatch-input:checked');
  var color = colorValue || (checkedMain ? (checkedMain.dataset.variantValue || checkedMain.value) : null);
  if (!color) return;
  var colorLower = color.toLowerCase().trim();
  document.querySelectorAll('[data-cross-sell-list] .js-color-swatches-wrapper, .cross_swiper .js-color-swatches-wrapper').forEach(function(wrap) {
    var inputs = wrap.querySelectorAll('.js-color-swatches input.color-swatch-input');
    var match = Array.from(inputs).find(function(i) {
      return (i.dataset.variantValue || i.value || '').toLowerCase().trim() === colorLower;
    });
    if (match && !match.checked) {
      match.checked = true;
      if (doUpdate && typeof updateSwatchSelection === 'function') updateSwatchSelection(match, wrap);
    }
  });
}

function initMobileCrossSellSwiper() {
  if (typeof Swiper === 'undefined') return;
  var el = document.querySelector('.cross_swiper.swiper');
  if (!el || el.swiper) return;
  requestAnimationFrame(function() {
    window.crossSwiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      scrollbar: { el: '.swiper-scrollbar', draggable: true },
    });
  });
}

function updateRecommendationHeading(color) {
  var section = document.querySelector('[data-rec-section]');
  if (!section) return;
  var h2 = section.querySelector('[data-color-heading]');
  if (!h2) return;
  if (color) {
    h2.textContent = (h2.dataset.headingPrefix || 'More in') + ' ' + color;
  } else {
    h2.textContent = h2.dataset.defaultHeading || (h2.dataset.headingPrefix || 'You May Also Like');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Page context
  var pageSwiperEl = document.querySelector('[data-page-recommendations] .product-recommendations');
  if (pageSwiperEl) { initRecommendationSwiper(pageSwiperEl); return; }

  var sec = document.querySelector('[data-rec-section]');
  if (!sec) return;

  _mainColorCache = sec.dataset.defaultColor || '';
  if (!_mainColorCache) {
    var el = document.querySelector('.main-product-page .color-swatch-input:checked');
    if (el) _mainColorCache = el.dataset.variantValue || el.value;
  }

  if (_mainColorCache) {
    showColorCollection(_mainColorCache);
  } else {
    var swiperEl = sec.querySelector('.product-recommendations');
    var wrapper = swiperEl ? swiperEl.querySelector('.swiper-wrapper') : null;
    if (swiperEl && wrapper) fetchShopifyRecommendations(wrapper, swiperEl, sec);
  }

  var mainProduct = document.querySelector('.main-product-page');
  if (mainProduct) {
    mainProduct.addEventListener('change', function(e) {
      if (e.target.matches('.color-swatch-input') && e.target.checked) {
        if (e.target.closest('.product-recommendations__list')) return;
        _mainColorCache = e.target.dataset.variantValue || e.target.value;
        showColorCollection(_mainColorCache);
        syncRecommendationSwatches(_mainColorCache);
        syncCrossSellSwatches(_mainColorCache, true);
      }
    });
  }
});

window.addEventListener('load', function() {
  if (typeof checkSwatches === 'function') checkSwatches();
  if (typeof initSwatchSwipers === 'function') initSwatchSwipers();
  syncCrossSellSwatches(null, false);
  initMobileCrossSellSwiper();
  if (_mainColorCache) syncRecommendationSwatches(_mainColorCache);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slideshow"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_with_text = () => {
		const main = document.querySelector('main');
		const headerOverlay = document.querySelector('.overlay');
		const colorScheme = document.querySelector('.header-color-theme-light');
		const colorSchemeDark = document.querySelector('.header-color-theme-dark');
		const firstSection = main && main.querySelector('.shopify-section');

		if (headerOverlay && firstSection && firstSection.classList.contains('product-slideshow-section')) {
			main.classList.add('page-about');
			if (colorSchemeDark) {
				headerOverlay.classList.add('theme-dark', 'header-color-background-5');
			}
			if (colorScheme) {
				headerOverlay.classList.remove('theme-dark', 'header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	banner_with_text();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_with_text();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const slideshow_section = () => {
		const main = document.querySelector('main');
		const headerOverlay = document.querySelector('.overlay');
		const page = document.querySelector('.template-page');
		const breadCrumb = document.querySelector('.main-breadcrumb');
		const firstSection = main && main.querySelector('.shopify-section');

		if (page && headerOverlay && firstSection && firstSection.classList.contains('slideshow-section') && breadCrumb) {
			breadCrumb.classList.add('template-page-breadcrumb');
			if (headerOverlay.classList.contains('theme-dark')) {
				breadCrumb.classList.add('color-background-5');
			}
		}
	};

	slideshow_section();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			slideshow_section();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_video = () => {
		const main = document.querySelector('main');
		const headerOverlay = document.querySelector('.overlay');
		const breadCrumb = document.querySelector('.main-breadcrumb');
		const colorScheme = document.querySelector('.header-color-light');
		const colorSchemeDark = document.querySelector('.header-color-dark');
		const firstSection = main && main.querySelector('.shopify-section');

		if (headerOverlay && firstSection && firstSection.classList.contains('video-banner-section')) {
			main.classList.add('page-about');
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark', 'header-color-background-5');
				breadCrumb && breadCrumb.classList.add('color-background-5');
			}
			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark', 'header-color-background-5');
				headerOverlay.classList.add('color-background-1');
				breadCrumb && breadCrumb.classList.remove('color-background-5');
			}
		} else {
			const pageAbout = document.querySelector('.page-about');
			const pageLookbook = document.querySelector('.page-lookbook');
			if (pageAbout || pageLookbook) {
				if (colorScheme) breadCrumb && breadCrumb.classList.add('color-background-5');
				if (colorSchemeDark) breadCrumb && breadCrumb.classList.remove('color-background-5');
			}
		}
	};

	banner_video();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_video();
		});
	});

  } catch(e) { console.error(e); }
})();
})();
